module.exports = __webpack_public_path__ + "img/kelly_newsom_ccp9j2n_cAQRk.20b98fd0.jpg";